<template>
  <svg
    @mouseover="mouseOver"
    @mouseleave="mouseLeave"
    id="baseline-close-24px"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    :tabindex="needToFocusCrossIcon ? 0 : -1"
    @click="iconClicked"
    @keyup.enter="iconClicked"
    :lang="narratorLang"
    :aria-label="$t('app.settings.pager.closeBtn.ariaLabel')"
>
    <path
      id="Path_8625"
      data-name="Path 8625"
      :fill="fillColor"
      d="M19,6.41,17.59,5,12,10.59,6.41,5,5,6.41,10.59,12,5,17.59,6.41,19,12,13.41,17.59,19,19,17.59,13.41,12Z"
    ></path>
    <path id="Path_8626" data-name="Path 8626" class="cls-2 close-icon" d="M0,0H24V24H0Z"></path>
  </svg>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'IconCross',
  props: {
    crossColor: {
      type: String,
      default: 'var(--grey)',
    },
    crossHoverColor: {
      type: String,
      default: 'var(--darkGrey)',
    },
  },
  data() {
    return {
      isHover: false,
    };
  },
  computed: {
    ...mapGetters({
      narratorLang: 'settings/getNarratorLanguage',
    }),
    fillColor() {
      if (this.isHover) {
        return this.crossHoverColor;
      }
      return this.crossColor;
    },
    needToFocusCrossIcon() {
      return !['Island', 'ShopScreen', 'Cards', 'OnboardingScreen'].includes(this.$route.name);
    }
  },
  methods: {
    iconClicked() {
      this.$emit('crossIconClicked');
    },
    mouseOver() {
      this.isHover = true;
    },
    mouseLeave() {
      this.isHover = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.cls-2 {
  cursor: pointer;
  fill: transparent;
}
</style>
